var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTick = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF19",
    d: "M16.734 24.467c-.407 0-.77-.18-.995-.452l-6.83-7.417c-.497-.543-.452-1.402.091-1.9.543-.497 1.402-.452 1.9.09l5.879 6.378L33.06 4.93c.543-.543 1.402-.543 1.9 0 .542.542.542 1.402 0 1.9L17.683 24.06c-.226.272-.587.407-.95.407z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D5D5",
    d: "M18 36C8.095 36 0 27.904 0 18S8.095 0 18 0c.769 0 1.357.588 1.357 1.357S18.769 2.713 18 2.713C9.588 2.713 2.714 9.588 2.714 18S9.588 33.286 18 33.286c8.412 0 15.286-6.874 15.286-15.286 0-.769.588-1.357 1.357-1.357S36 17.231 36 18c0 9.904-8.096 18-18 18z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tick.d2e8ede3.svg";
export { ForwardRef as ReactComponent };